export const locale = {
    lang: 'en',
    data: {
      'WIZARD': {
        'TESTTITULO': 'WIZARD TITLE :V',
        'CARGANDO': 'Loading acquired products',
        'SINPRODS': 'You have not acquired this product',
        'LANDING': {
          'PRODUCTO': {
            'IZZI':{
              'TITULO': 'Welcome to izzi',
              'CURRENT': 'This is your current izzi process',
              'FINISHED': 'This is a finished izzi process',
              'RESULTS': {
                'CURRENT': 'Izzi process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current izzi process'
              }
            },
            },
          'DONE': 'Application year: ',
          'LEGA': 'Legacy results',
          'FOCUS': 'SURVEY´S TO FOCUS AREA',
          'ENTRAR': 'Start'
        },
        'STEPSTAT': {
          'LOCK': 'Step locked',
          'PEND': 'Step open',
          'COMP': 'Step completed'
        },
        'NOPRODUCTS': {
          'TITULO': 'Your company has no acquired products',
          'SUBTI': 'Information about the offer'
        },
        'IZZI': {
          'TITULO': 'Izzi',
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'NPS Edition'
            },
            'STP1-1': {
              'WIZBT': 'Statements',
              'TITULO': 'Statements',
              'SUBTI': 'Statements edit'
            },
            'STP2': {
              'WIZBT': 'Cultural practices',
              'TITULO': 'Cultural practices',
              'SUBTI': 'Evaluation of cultural practices (ECP)'
            },
            'STP_CONTROL': {
              'WIZBT': 'Control question',
              'TITULO': 'Control question',
              'SUBTI': 'Editing the control question'
            },
            'STP3': {
              'WIZBT': 'Demographics',
              'TITULO': 'Demographics',
              'SUBTI': 'Insert the demographics information to be shown in the survey. NOTE: Demographics in yellow are optional'
            },
            'STP3-1': {
              'WIZBT': 'Open questions',
              'TITULO': 'Open questions',
              'SUBTI': 'Insert the open questions'
            },
            'STP4': {
              'WIZBT': 'Additionals',
              'TITULO': 'Additionals',
              'SUBTI': 'Insert additional questions for the survey'
            },
            'STP4-1': {
              'WIZBT': 'Generate survey',
              'TITULO': 'Generate survey',
              'SUBTI': 'Generate the survey',

              'WIZBT2': 'Survey',
              'TITULO2': 'Survey',
            },
            'STP5': {
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'Upload your company participant employees database'
            },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule the survey\'s launching and reminders dates'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your pilot participants'
            },
            'STP8': {
              'WIZBT': 'Survey close',
              'TITULO': 'Survey close',
              'SUBTI': 'Progress before the closing of the survey'
            }
          }
        }
      }
    }
};
